<template>
    <section>
        
        <b-container fluid>
            <h1 class='mx-3'>Вакцинация от COVID-19: Опросник</h1>

            <b-progress max="100"  height="2rem" class='mt-1 mb-3 mx-3'>
                <b-progress-bar :value="progress" variant='info'>
                    <span>Страница: <strong>{{ tabIndex }} / 4</strong></span>
                </b-progress-bar>
            </b-progress>


            <personal-data ref='personalData' v-if='tabIndex === 1'></personal-data>
            <interview ref='interview' v-if='tabIndex === 2'></interview>
            <last-two-weeks ref='lastTwoWeeks' v-if='tabIndex === 3'></last-two-weeks>
            <medications ref='medications' v-if='tabIndex === 4'></medications>


            <b-button-group class='wizard-step-buttons mr-3 my-3'>
                <b-button @click='backToPrevious' variant="outline-dark">Назад</b-button>
                <b-button @click='toInterview' variant='success' v-if='tabIndex < 4'>Далее</b-button>
                <b-button variant='success' v-if='tabIndex === 4' @click='toInterview'>Заверишть</b-button>
            </b-button-group>
        </b-container>
    </section>
</template>

<script>
import PersonalData from './../components/interview-components/PersonalData'
import Interview from "./../components/interview-components/Interview"
import lastTwoWeeks from "./../components/interview-components/LastTwoWeeks"
import Medications from "./../components/interview-components/Medications"

export default {
    name: 'interview-wizard',
    components: { PersonalData, Interview, lastTwoWeeks, Medications },
    data() {
        return {
            tabIndex: 1,
            progress: 0
        }
    },
    methods: {
        toInterview() {

            switch(this.tabIndex) {
                // case 1: this.$refs.personalData.concatAnswers(); break;
                case 2: this.$refs.interview.concatAnswers(); break;
                case 3: this.$refs.lastTwoWeeks.concatAnswers(); break;
                case 4: this.$refs.medications.concatAnswers(); break;
            }
            this.tabIndex += 1;
            window.scrollTo(0, 0);
        },
        backToPrevious() {
            this.tabIndex -= 1;
            window.scrollTo(0, 0);
        },
    },
    created() {
        this.progress = 100 / 4 * this.tabIndex;
    },
    watch: {
        tabIndex(index) {
            this.progress = 100 / 4 * index;
        }
    },
    computed: {

    }
}
</script>

<style>
.wizard-step-buttons {
    float: right;
}
.wizard-step-buttons .btn {
    min-width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PollAnswers.vue